import styled from "styled-components";
import { Text } from "~/components/elements";
import theme from "~/styles/theme";

export const BubblesHolder = styled.div`
  margin: 0 auto 8px;
  max-width: 313px;
  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 480px;
    margin-bottom: 16px;
  }
`;

export const Bubble = styled.div`
  display: inline-block;
  vertical-align: middle;
  font-weight: 700;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  color: ${(props) =>
    props.active
      ? '#FCC800'
      : '#969696'};
  font-size: 33.6px;
  line-height: 56px;
  text-align: center;
  font-family: ${theme.typography.fontFamily};
  background: ${(props) =>
    props.active
      ? '#0D5BA8'
      : '#D8D8D8'};
  @media (min-width: ${theme.breakpoints.values.md}px) {
    width: 56px;
    height: 56px;
    line-height: 52px;
    font-size: 32px;
    position: relative;
  }
`;
export const BubbleBar = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 65px;
  height: 4px;
  background: ${(props) =>
    props.active
      ? '#0D5BA8'
      : '#D8D8D8'};
  @media (min-width: ${theme.breakpoints.values.md}px) {
    width: 150px;
  }
`;

export const LabelHolder = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 320px;
  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 500px;
  }

`;

export const BubbleLable = styled(Text)`
  color: ${(props) =>
    props.active
      ? '#1B1B19'
      : '#969696'} !important;
  font-size: 12px;
  text-align: center;
  font-weight: 600;
  display: block;
  position: absolute;
  line-height: 100%;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  width: 300px;
  pointer-events: none;
  top: 100%;
  margin-top: 15px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    font-size: 16px;
  }
`;
